import { scrambleReveal } from './textScramble.js';

/**
 * "MISSION COMPLETE" overlay + continue prompt, shown centered when every enemy
 * in a combat scenario has been destroyed. A static, pointer-events-free badge
 * (the actual resume is the R key, handled by App); CSS drives the fade-in (over
 * two seconds) via the `is-visible` class toggled by {@link show} / {@link hide}.
 * On show the title runs a centered "decode" reveal (see {@link scrambleReveal}).
 */
export default class MissionCompleteOverlay {
  constructor({ canEndMission = false } = {}) {
    const el = document.createElement('div');
    el.id = 'mission-complete-overlay';

    const title = document.createElement('div');
    title.className = 'mission-complete-title';
    title.textContent = 'MISSION COMPLETE';
    this.title = title;
    this.titleText = 'MISSION COMPLETE';
    this.cancelReveal = null;

    const prompt = document.createElement('div');
    prompt.className = 'mission-complete-prompt';
    // Esc ends the mission and opens the score sheet; R keeps flying.
    prompt.textContent = canEndMission
      ? 'Press R to Continue  ·  Esc to End Mission'
      : 'Press R to Continue';

    el.append(title, prompt);
    this.prompt = prompt;
    this.el = el;
    document.getElementById('app').appendChild(el);
  }

  show() {
    this.el.classList.add('is-visible');
    this.cancelReveal?.();
    this.cancelReveal = scrambleReveal(this.title, this.titleText);
  }

  /** Show/hide the continue prompt (hidden when App moves the player on itself). */
  setPromptVisible(v) {
    this.prompt.style.display = v ? '' : 'none';
  }

  hide() {
    this.el.classList.remove('is-visible');
    this.cancelReveal?.();
    this.cancelReveal = null;
    this.title.textContent = this.titleText;
  }

  dispose() {
    this.cancelReveal?.();
    this.el.remove();
  }
}
